import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=6876afac&scoped=true&"
import script from "./goodsInfo.vue?vue&type=script&lang=js&"
export * from "./goodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./goodsInfo.vue?vue&type=style&index=0&id=6876afac&lang=scss&scoped=true&"
import style1 from "./goodsInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6876afac",
  null
  
)

export default component.exports